module.exports = __webpack_public_path__ + "img/1.515547e2.png";